import { combineReducers } from '@reduxjs/toolkit';

import { loadingOvp } from './loadingOvp';
import { engineeringCalendar } from './engineeringCalendar';

export const timesheet = combineReducers({
  loadingOvp,
  engineeringCalendar,
});
